import styled from 'styled-components';

export const CartItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  margin-top: 50%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;

  > span {
    font-size: 1.5rem;
    font-weight: 500;
    margin-left: 10px;
  }
`;
export const Body = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px 0px 10px 0px;
`;

export const ProductDetails = styled.div`
  margin-left: 20px;
  margin-top: 10px;
  > div:nth-child(1) {
    font-weight: 500rem;
    font-size: 1.1rem;
  }
  > div:nth-child(2) {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.63);
    margin-top: 5px;
  }
`;
export const Footer = styled.div``;

export const Thumbnail = styled.div`
  position: relative;
  width: 145px;
  height: 125px;
  margin: 10px 10px 10px 10px;
  cursor: pointer;
`;

export const ReasonInputWrapper = styled.div`
  textarea {
    width: 90%;
    padding: 10px;
    margin: 10px 0px;
    border: 1px solid rgba(0, 0, 0, 0.94);
    border-radius: 2px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const FrequencyTitle = styled.div`
  font-weight: 500;
  color: green;
`;
